import { render, staticRenderFns } from "./TeamIconTag.vue?vue&type=template&id=f7223090&scoped=true&"
import script from "./TeamIconTag.vue?vue&type=script&lang=js&"
export * from "./TeamIconTag.vue?vue&type=script&lang=js&"
import style0 from "./TeamIconTag.vue?vue&type=style&index=0&id=f7223090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7223090",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7223090')) {
      api.createRecord('f7223090', component.options)
    } else {
      api.reload('f7223090', component.options)
    }
    module.hot.accept("./TeamIconTag.vue?vue&type=template&id=f7223090&scoped=true&", function () {
      api.rerender('f7223090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/TeamIconTag.vue"
export default component.exports